// src/components/Header.js
import React, { useEffect, useState } from 'react';
import styles from './Header.module.scss'; // Import the CSS for the header
import { useNavigate, useLocation } from 'react-router-dom';
import { imageMappings } from '../../../assets/images/ImageKeyMapping';
import { GAME_SUMMARY } from '../../../assets/constants/app.constant';
import AdBanner  from '../GoogleAds/AdBanner';

const Header = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (slug = '/') => {
    setSearchOpen(false);
    navigate(slug);
  };


  useEffect(() => {
    const outlet = document.querySelector(".outlet");
    if (outlet) {
      outlet.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);


  const handleSearchSubmit = () => {
    // Assuming GAME_DETAILS is an object, and we need to filter over the values of the object
    const results = GAME_SUMMARY.filter((game) =>
      game.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      game.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    console.log("resulst",)
    setSearchResults(results);
  };
  

  const goToBrainGame = () => {
    window.open('https://brain.gameplay.in.net', '_blank');
  }


  useEffect(() => {
    if(searchQuery) {
      handleSearchSubmit();
    }
  }, [searchQuery])

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <i className="fas fa-image"></i>
        <img onClick={() => handleNavigation('/')} src={imageMappings.appLogo} alt="GamePlay" />
        {/* <span onClick={() => handleNavigation('/')}>Gamers Zone</span> */}
      </div>
      <nav>
        <img
          src={imageMappings.searchIcon}
          alt="search"
          width={25}
          height={25}
          className={styles.searchIcon}
          onClick={() => setSearchOpen(true)}
        />
        <a onClick={() => handleNavigation('/all-games')}>Games</a>
        {/* <a onClick={goToBrainGame}>Games</a> */}
        {/* <a onClick={() => handleNavigation('/blogs')}>Blogs</a> */}
        {/* <a>Help</a> */}
      </nav>
      {searchOpen && (
        <div className={styles.searchPopup}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="Search for games..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {/* <button onClick={handleSearchSubmit} className={styles.searchButton}>
              <img
                src={imageMappings.searchIcon}
                alt="search"
                width={20}
                height={20}
              />
            </button> */}
            <button
              className={styles.closeButton}
              onClick={() => setSearchOpen(false)}
            >
              &times;
            </button>
          </div>
          <div className={styles.searchResults}>
            {searchResults.map((result) => (
              <div
                key={result.id}
                className={styles.searchItem}
                onClick={() => handleNavigation(`/game-detail/${result.slug}`)}
              >
                {result.title}
              </div>
            ))}
            {searchResults.length === 0 && searchQuery && (
              <div className={styles.noResults}>No Result Found ...</div>
            )}

          {searchResults.length === 0 && !searchQuery && (
              <div className={styles.noResults}>Search your query ...</div>
            )}
          </div>

          {/* <AdBanner id={301} /> */}
        </div>
      )}
    </header>
  );
};

export default Header;
